import { render, staticRenderFns } from "./af-checks.vue?vue&type=template&id=1455c199&"
import script from "./af-checks.vue?vue&type=script&lang=ts&"
export * from "./af-checks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports